import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import { usePerms } from 'contexts/PermsContext';
import CreateUser from 'pages/CreateUser/CreateUser.index';
import { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import { getWorkplaceMembers } from 'services/organization/organization.service';
import { getAllRoles } from 'services/roles/roles.service';
import { getVisibleUsers } from 'utils/roleUtils';
import MembersTab from './Components/MembersTab';

export default function UserManager() {
  const [params] = useSearchParams();
  const perms = usePerms();
  const [roleList, setRoleList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    (async () => {
      await getAllRoles().then((res) => {
        setRoleList([...res.data.result]);
      });

      await getWorkplaceMembers(getVisibleUsers(perms)).then((res) => {
        setMemberList([...res.data.result]);
      });
    })();
  }, []);

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'users':
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers']))
          return (
            //TODO: refactor members tab
            <MembersTab
              list={memberList}
              setMemberList={setMemberList}
              mousePosition={mousePosition}
              perms={perms}
              setMousePosition={setMousePosition}
              roleList={roleList}
            />
          );
        break;
      case 'create new user': //create member
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditUsers']))
          return <CreateUser />;
        break;
      default:
        if (perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers']))
          return (
            //TODO: refactor members tab
            <MembersTab
              list={memberList}
              setMemberList={setMemberList}
              mousePosition={mousePosition}
              perms={perms}
              setMousePosition={setMousePosition}
              roleList={roleList}
            />
          );
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100">
      {/* header */}
      {perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers']) &&
        perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditUsers']) && (
          <>
            <div className="d-none d-lg-block flex-shrink-0">
              <TabsHeader options={[{ option: 'Users' }, { option: 'Create New User' }]} />
            </div>
            <div className="d-block d-lg-none flex-shrink-0">
              <MobileTabsHeader options={[{ option: 'Users' }, { option: 'Create New User' }]} />
            </div>
          </>
        )}

      {/* content */}
      <div className="flex-grow-1 overflow-hidden min-h-0">{renderTab()}</div>
    </Container>
  );
}
